module.exports = __webpack_public_path__ + "material-design.d2a55d331bdd1a7ea97a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design/material-design.woff?v=2.2.0
// module id = 896
// module chunks = 3